import { useEffect, useState } from "react";
import { Sparkles, Loader2, CheckCircle2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { studio, apiError, btnGhost } from "@/lib/studioApi";

export const AiEngineSettings = ({ value, onChange }) => {
  const [engines, setEngines] = useState([]);
  const [testing, setTesting] = useState("");
  const [result, setResult] = useState(null);

  useEffect(() => { studio.get("/ai/engines").then(({ data }) => setEngines(data.engines)).catch(() => {}); }, []);

  const test = async (key) => {
    setTesting(key); setResult(null);
    try {
      const { data } = await studio.post("/ai/test", { engine: key });
      setResult(data);
    } catch (e) { toast.error(apiError(e)); } finally { setTesting(""); }
  };

  return (
    <section data-testid="ai-engine-settings" className="mt-6 rounded-2xl border border-[#E2E7F7] bg-white p-5 shadow-[0_1px_2px_rgba(15,38,69,0.04)] sm:p-6">
      <h2 className="font-heading text-[15px] font-bold text-[#0F2645] inline-flex items-center gap-2"><Sparkles className="h-4 w-4 text-[#F97316]" /> Moteur d'intelligence artificielle</h2>
      <p className="mt-0.5 text-xs text-[#5C6A87]">Utilisé pour les devis dictés, rapports, réponses aux clients, contrats et modèles suggérés. Si le moteur choisi ne répond pas, Devisto bascule automatiquement sur l'autre.</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-2" role="radiogroup" aria-label="Moteur IA">
        {engines.map((e) => {
          const active = (value || "claude") === e.key;
          return (
            <div key={e.key} className={`rounded-xl border p-4 transition-colors ${active ? "border-[#3A5CC8] bg-[#EEF1FC]" : "border-[#E2E7F7] bg-white hover:border-[#C9D4F4]"}`}>
              <button type="button" role="radio" aria-checked={active} data-testid={`ai-engine-${e.key}`} onClick={() => onChange(e.key)} className="flex w-full items-start gap-3 text-left">
                <span className={`mt-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${active ? "border-[#3A5CC8] bg-[#3A5CC8]" : "border-[#C9D4F4]"}`}>{active && <span className="h-1.5 w-1.5 rounded-full bg-white" />}</span>
                <span className="min-w-0">
                  <span className="block text-sm font-semibold text-[#0F2645]">{e.label}</span>
                  <span className="block text-xs text-[#5C6A87]">{e.hint}</span>
                  <span className="mt-1 block font-mono text-[10px] text-[#93A0BC]">{e.model}</span>
                </span>
              </button>
              <button type="button" data-testid={`ai-engine-test-${e.key}`} disabled={!!testing} onClick={() => test(e.key)} className={`${btnGhost} mt-3 min-h-[34px] px-3 text-xs`}>
                {testing === e.key ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ShieldCheck className="h-3.5 w-3.5" />} Tester
              </button>
            </div>
          );
        })}
      </div>
      {result && (
        <p data-testid="ai-engine-test-result" className="mt-3 flex items-start gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs text-[#0F2645]">
          <CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-600" /><span><span className="font-semibold">{result.label}</span> a répondu en {(result.ms / 1000).toFixed(1)} s : « {result.reply} »</span>
        </p>
      )}
      <p className="mt-3 text-[11px] text-[#93A0BC]">Le choix s'applique après « Enregistrer ».</p>
    </section>
  );
};
